import React from "react";
import { createRoot } from 'react-dom/client';
import "leaflet/dist/leaflet.css";

import "../src/Dashboard/assets/css/icons.css";
import AppContainer from "./containers/AppContainer";
import EN from "../src/Dashboard/locales/en.json";
import FIN from "../src/Dashboard/locales/fin.json";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { MsalProvider, useMsal } from "Auth/msal-context";
import { msalConfig, loginRequest } from "Auth/auth-config";
import { BrowserRouter as Router } from "react-router";
import config from "config";
import { Provider } from "react-redux";
import WithAxios from "Auth/withAxios";
import store from './store';
import { muiDarkTheme } from "../src/theme/muiTheme";
import { ThemeProvider } from '@mui/material/styles';
import ThemeWrapper from "../src/theme/ThemeWrapper";
import { ThemeContextProvider } from "../src/theme/ThemeContextProvider";


i18next.init({
  interpolation: { escapeValue: false },
  fallbackLng: "en",
  // debug: true,
  resources: {
    en: {
      common: EN,
    },
    fi: {
      common: FIN,
    },
  },
});

if (config.APP_ENV == "Cloud" && config.NODE_ENV !== "LocalDevelopment") {
  config.STREAMER_URL = "https://" + window.location.hostname;
  config.COMMAND_URL = "https://" + window.location.hostname;
  config.DATA_URL = "https://" + window.location.hostname;
  config.CONFIGURATION_URL = "https://" + window.location.hostname;
  config.SETTING_URL = "https://" + window.location.hostname;
  config.OS_ANALYTICS_URL = "https://" + window.location.hostname;
}

const MainApp = () => {
  const { user } = useMsal();
  if (user) {
    return (
      <I18nextProvider i18n={i18next}>
        <WithAxios>
          <AppContainer />
        </WithAxios>
      </I18nextProvider>
    );
  } else {
    return <div>Loading...</div>;
  }
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <MsalProvider msalConfig={msalConfig} scopes={loginRequest}>
    <Provider store={store}>
      <Router>
        {/* <ThemeProvider theme={muiDarkTheme}> */}
        <ThemeContextProvider>
          <ThemeWrapper>
            <MainApp />
          </ThemeWrapper>
        </ThemeContextProvider>
        {/* </ThemeProvider> */}
      </Router>
    </Provider>
  </MsalProvider>
);
